export * from './ports/types';
export { MockMediaExport } from './mocks/mockMediaExport';

export {
  FrameCapturer,
  type CaptureOptions,
  type CapturedFrame,
  type CaptureSequenceResult,
} from './internal/FrameCapturer';

export {
  WatermarkCompositor,
  type WatermarkConfig,
} from './internal/WatermarkCompositor';

export {
  GifEncoder,
  type GifEncodeResult,
} from './internal/GifEncoder';

export {
  MediaRecorderEncoder,
  type VideoEncodeOptions,
  type VideoEncodeResult,
} from './internal/MediaRecorderEncoder';

export {
  EncoderAdapter,
  type EncoderAdapterOptions,
} from './internal/EncoderAdapter';

export {
  MediaExportService,
  type MediaExportServiceDependencies,
} from './internal/MediaExportService';

import type { IMediaExportPort } from './ports/types';
import { MediaExportService, type MediaExportServiceDependencies } from './internal/MediaExportService';

/**
 * MediaExportPort のファクトリ関数
 * 本番・プロトタイプ向けの本実装ファサード (MediaExportService) を生成して返却
 */
export function createMediaExportPort(dependencies?: MediaExportServiceDependencies): IMediaExportPort {
  return new MediaExportService(dependencies);
}
